import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles((theme) => ({
  heading: {
    color: theme.colors.brandGray[0],
    lineHeight: '17.5px',
    paddingBottom: '12px',
    paddingTop: '27px'
  },

  navLinkItem: {
    '&.mantine-NavLink-root': {
      borderRadius: '8px',

      '&[data-active=true]': {
        backgroundColor: theme.colors.brandGray[1],
        fontWeight: 'bold',
        color: '#101828'
      },
      '@media (max-width: 992px)': {
        paddingRight: '8px',
        paddingLeft: '8px'
      }
    }
  }
}));
